import { createContext } from "react";
export var ToastContext = createContext(undefined);
